import { isInternational } from '../global/_checkForInternational';

const checkShipInternational = (shipInternational, fromQV) => {
    if (shipInternational == 'N') {
        if (isInternational()) {
            if (fromQV) $(".qv-intDiv").html('<div id="preorder-alert" class="alert alert-danger alert-dismissible"' + 'role="alert">This item is not available for international purchase.</div>');
            else {
                $(".sylistSuggestsBody, #product-list-items").remove();
                $(".intDiv").html('<div id="preorder-alert" class="alert alert-danger alert-dismissible"' +
                    'role="alert">This item is not available for international purchase.</div>');
            }
        }
    }
};

const allDevicesCheckShipInternationalOnLoad = () => {
    checkShipInternational($('#shipInternational').html(), false);
};

export {
    allDevicesCheckShipInternationalOnLoad,
    checkShipInternational
}
